import { logError } from './logging';

/**
 * Safely parses a JSON string.
 * @param {Object} options - Options object.
 * @param {string} options.jsonString - The JSON string to parse.
 * @returns {Object} - The parsed JSON object.
 */
export const safeJsonParse = ({ jsonString }) => {
  let parsed = null;
  try {
    parsed = JSON.parse(jsonString);
  } catch (error) {
    logError({
      label: 'safeJsonParse',
      error,
      message: 'Error parsing JSON string',
      extraData: { jsonString }
    });
    return jsonString;
  }

  return parsed;
};
